import axios from "axios";

import { clearUser } from "../redux/slices/userSlice";
import store from "../redux/store";
import { formatErrorMessages } from "../utils/errorHandler";
import { getLanguage } from "../utils/getLanguage";

// Create an Axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:5000", // Base URL
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptors to handle requests globally
apiClient.interceptors.request.use(
  (config) => {
    const { options = {} } = config;

    // Handle language unless explicitly disabled
    if (!options.withoutLanguage) {
      const lang = getLanguage();
      config.headers["lang"] = lang;
    }

    // Handle access_token unless explicitly disabled
    if (!options.withoutToken) {
      const { user } = store.getState().user;
      if (user?.access_token) {
        config.headers.Authorization = `Bearer ${user.access_token}`;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor for global error handling
apiClient.interceptors.response.use(
  (response) => response.data.data || response.data,
  (error) => {
    const { response } = error;

    if (response) {
      // Handle 401 Unauthorized error
      if (response.status === 401) {
        store.dispatch(clearUser()); // Dispatch the logout action
      }

      // Handle other errors with formatted messages
      if (response.data.errors) {
        return Promise.reject(formatErrorMessages(response.data.errors));
      } else {
        return Promise.reject(response.data.message);
      }
    }

    // Return the original error if no response is available
    return Promise.reject(error);
  }
);

export default apiClient;
